import { render } from "./TopToolBar.vue?vue&type=template&id=13c07cca&scoped=true&ts=true"
import script from "./TopToolBar.vue?vue&type=script&lang=ts"
export * from "./TopToolBar.vue?vue&type=script&lang=ts"

import "./TopToolBar.vue?vue&type=style&index=0&id=13c07cca&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c07cca"]])

export default __exports__